import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Event, NavigationEnd, NavigationError, NavigationStart, Router } from "@angular/router";
// import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Location } from '@angular/common';

import { AppService } from '@app/services/app/app.service';
import { WorkflowsService } from '@app/services/settings/workflows.service';
import { VersionsService } from '@app/services/app/versions.service';
import { TitleService } from '@core/services/title.service';

import * as Objects from '@core/objects';
import { WysiwygData } from '@core/models/wysiwyg-data.model';

import { SelectItem } from '@core/models/select-item.model';
import { AddProjectService, } from '@app/services/app/add-project.service';
import { AddRequest, AddProjectErrors } from '@app/models/add-project';

@Component({
    selector: 'project-add-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class ProjectAddMainComponent implements OnInit, OnDestroy{

    public readonly ACCESS = "access_global_new_request";

    public readonly STATUS_LOADING = 0;
    public readonly STATUS_DONE = 1;
    public readonly STATUS_NOT_ALLOWED = 2;

	public access:boolean = true;
    public status: number = 0;
    public creatingNewProject: boolean = false;
    // flags for leave the page conditions
    public allowLeave: boolean = false;
    public leavingModal: boolean = false; // For leaving without submitting
    public errorModal: boolean = false;   // For validation errors (due_date, info, etc.)
    public forbiddenErrorModal: boolean = false; // For forbidden & unauthorized
    public generalErrorModal: boolean = false;   // For other errors
    private urlTo: string = '';
    private uploading: boolean = false;

    public workflowsList: Array<SelectItem>; // items for wf selector 
    public addProjectData: AddRequest = null;
    public activeWorkflows: Array<Objects.Workflow> = [];
    // editor controls
    public editorModules: any = [[{ 'list': 'ordered'}, { 'list': 'bullet' }]];
    // public infoControl: FormControl;
    // for origin version case
    public version: Objects.Version = null;
    public versionId: number = null;
    public workflowId: number = null;
    
    // response success
    public savedProject: Objects.Request = null;
    // header data
    public breadcrumbs: any = [
        {
            title: "",
            link: ['']
        }
    ];

    errors: AddProjectErrors = {
        due_date: false,
        info: false,
        files: false,
        labels: false,
        version: false,
        workflow: false,
        forbidden: false,
        unauthorized: false,
        server: false,
        other: false
    };

    // protected newProjectSubscriptor: Subscription;
    // protected navigationSubscriber: Subscription;
    // protected errorSubscriptor: Subscription;


    protected subscriptions: Subscription = new Subscription();

	constructor(
        private router: Router,
        private location: Location,
        public appSrv: AppService,
        private workflowsSrv: WorkflowsService,
        private versionsSrv: VersionsService,
        private titleSrv: TitleService,
        private activeRoute: ActivatedRoute,
        private AddProjectSrv: AddProjectService,
        // private fb: FormBuilder
        ){}

    @HostListener('window:beforeunload', ['$event'])
    onProjectAddLeave(event: any): void {
        event.preventDefault(); 
        event.returnValue = false;
    }

	ngOnInit(){
        this.titleSrv.set("Add - Projects");
        this.subscriptions.add(
            this.AddProjectSrv.selectData().subscribe((newProject: AddRequest) => {
                if(newProject != null)
                    this.addProjectData = newProject;
            })
        );


        this.subscriptions.add(
            this.AddProjectSrv.selectErrors().subscribe((errors) => {
                this.errors = errors;
                // Update modal states based on error flags
                this.errorModal = this.hasDataValidationErrors(); // Validation errors (due_date, info, etc.)
                this.forbiddenErrorModal = errors.forbidden || errors.unauthorized; // Forbidden or unauthorized
                // Note: server error will also trigger generalErrorModal
                this.generalErrorModal = errors.other || errors.server; // Other errors or server
            })
        );


        this.subscriptions.add(
            this.AddProjectSrv.selectSavedProject().subscribe((savedProject) => {
                this.savedProject = savedProject;
            })
        );

        this.subscriptions.add(
            this.AddProjectSrv.selectCreatingNewProject().subscribe((creating) => {
                this.creatingNewProject = creating;
            })
        );

        // control access new request
        this.subscriptions.add(
            this.appSrv.getSession().subscribe( (session: any) => {
                this.access = session.options.access.hasOwnProperty(this.ACCESS)? session.options.access[this.ACCESS] : false;
                if (this.access){
                    this.loadWorkflows(); // first thing to do
                } else {
                    this.status = this.STATUS_NOT_ALLOWED;
                }
            })
        );
        // get params
        if(this.activeRoute.snapshot.queryParamMap.has('workflow')) {
            this.workflowId = +this.activeRoute.snapshot.queryParamMap.get('workflow');
        }
        // in case of origin version get labels
        if(this.activeRoute.snapshot.queryParamMap.has('version')) {
            
            this.subscriptions.add(
                this.versionsSrv.getById$(+this.activeRoute.snapshot.queryParamMap.get('version')).subscribe((version: Objects.Version) => {
                    if (version != null){
                        this.versionId = version.id;
                        this.version = version;
                        //  ensure to set labels and version origin in store
                        if(this.addProjectData != null && this.addProjectData.labels.length == 0)
                            this.addProjectDataChange({labels: version.labels.map((l:Objects.Label) => { return {...l}; })});
                        if(this.addProjectData != null && this.addProjectData.version == null){
                            this.addProjectDataChange({version: this.version.id});
                        }
                    }
                })
            );
        }

        // router control for leaving
        this.subscriptions.add(
            this.router.events.subscribe((event: Event) => {
                if (event instanceof NavigationStart) {
                    if(this.router.url != event.url){
                        // console.debug(" new route is out --->",this.router.url, event.url);
                        this.leavingModal = true;
                        this.urlTo = event.url;
                    }
                }
            })
        );        
        
	}

    ngOnDestroy() {
        this.leavingModal = false;
        this.subscriptions.unsubscribe();
    }

    init() {   

        if (this.addProjectData == null){
            if (this.workflowId == null)
                this.workflowId = this.activeWorkflows[0].id; // must be string for the selector component
            this.AddProjectSrv.init(+this.workflowId,this.versionId );
            // ensure the version tags is set in the editor.
            if(this.version != null && this.addProjectData.labels.length == 0)
                this.addProjectDataChange({labels: this.version.labels.map((l:Objects.Label) => { return {...l}; })});

        }

        // this.infoControl = new FormControl(this.addProjectData != null ? this.addProjectData.info : '',[Validators.required]);
        // this.form = this.fb.group({});
        // this.form.addControl("info", this.infoControl);
        this.status = this.STATUS_DONE;
    }

    protected loadWorkflows(){
        // get workflows
        this.workflowsSrv.getWorkflows$().subscribe((workflows: Array<Objects.Workflow>) => {
            if( workflows.length == 0){
                this.status = this.STATUS_NOT_ALLOWED;
                return false;
            }
            this.activeWorkflows = workflows.filter((wf: Objects.Workflow) => {return wf.active;});
            if( this.activeWorkflows.length == 0){
                this.status = this.STATUS_NOT_ALLOWED;
                return false;
            }
            
            this.workflowsList = this.activeWorkflows.map((wf: Objects.Workflow) => {
                    return {
                        title: wf.name,
                        value: wf.id.toString(),
                        selected: this.workflowId == wf.id ? true : false
                    };
            });

            // we init component after load workflow.
            this.init();
            
        });
    }

    public onSubmit(){
        this.creatingNewProject = true;
        // console.debug("submit project form:",this.addProjectData);
        this.AddProjectSrv.submitAddProject(this.addProjectData);
    }

    public onChangeLabels(labels: Array<Objects.Label>){
        this.addProjectDataChange({labels: labels}); 
    }

    public onSetFiles(files: Array<Objects.FileMetadata>){
        this.addProjectDataChange({files: files}); 
        this.uploading = false;
    }

    public onUploading(uploading: boolean){
        this.uploading = uploading;
    }

    public onInfoChange(editorData: WysiwygData){
        if(editorData.text.trim() != ''){
            this.addProjectDataChange({info: editorData.html });
        }
    }

    public onSelectDate(date: string){
        this.addProjectDataChange({due_date: this.addProjectData.due_date == date ? null : date});
    }

    public onSelectWorkflow(workflow: SelectItem){
        this.addProjectDataChange({workflow: +(workflow.value) });
    }

    // checks to show the button SAVE
    isProjectReady () {
        return (
            !this.uploading &&
            this.addProjectData !== null && 
            this.addProjectData.labels.length > 0 &&
            this.addProjectData.workflow != null &&
            this.addProjectData.info.trim() != ''
            //
            // this.form.get('info').value.trim() != ''
           );
    }

    onOpenProject(){
        if (this.savedProject != null){
            this.router.navigate(['/projects/'+this.savedProject.id]);
        }
    }

    onStartNew(){
        this.savedProject = null;
    }

    onCancel(){
        this.AddProjectSrv.clear();
        this.allowLeave = true;
        this.location.back();
    }

    onDiscard(){
        this.AddProjectSrv.clear();
        this.leavingModal = false;
        this.allowLeave = true;
        this.router.navigateByUrl(this.urlTo);
    }

    onDismiss(){
        this.errorModal = false;
        this.generalErrorModal = false;
        this.forbiddenErrorModal = false;
    }

    onStay(){
        this.leavingModal =false;
        this.allowLeave = false;

    }

    addProjectDataChange(changes: Partial<AddRequest>){
        this.AddProjectSrv.update( changes );
    }

    // Check if any error flags for data are true 
    hasDataValidationErrors(): boolean {
        return (
            this.errors.due_date ||
            this.errors.info ||
            this.errors.files ||
            this.errors.labels ||
            this.errors.version ||
            this.errors.workflow
        );
    }

}
